import React from "react";

import { cn } from "@/lib/cn";

type SpinnerProps = React.ComponentProps<"span"> & {
  size?: number;
};
export const Spinner = ({ size = 50, className, style, ...props }: SpinnerProps) => (
  <span
    // The ring size is a prop, so it reaches the classes through a custom property
    style={{ "--spinner-size": `${size}px`, ...style } as React.CSSProperties}
    className={cn(
      "flex justify-center",
      // A faint track with a solid arc, in the primary colour
      "before:block before:size-(--spinner-size) before:animate-[spin_0.8s_linear_infinite] before:rounded-full before:border-2 before:border-primary-subtle before:border-t-primary before:content-['']",
      className,
    )}
    {...props}
  />
);
